export default "__VITE_ASSET__9a57d64d__"